/** `+additions −deletions`, in the diff colours. */
export function DiffStat({
  additions,
  deletions,
  className,
}: {
  additions: number;
  deletions: number;
  className?: string;
}) {
  return (
    <span className={className}>
      <span className="text-diff-add">+{additions}</span> <span className="text-diff-del">−{deletions}</span>
    </span>
  );
}
